import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const createLead = (data) => api.post("/leads", data).then((r) => r.data);
export const getLeads = () => api.get("/leads").then((r) => r.data);
export const getLeadStats = () => api.get("/leads/stats").then((r) => r.data);
export const updateLeadStatus = (id, status) =>
  api.patch(`/leads/${id}`, { status }).then((r) => r.data);
export const deleteLead = (id) => api.delete(`/leads/${id}`).then((r) => r.data);
